import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';

export const productTitle: ResolveFn<string> = () => inject(I18NextPipe).transform('mbs-ui:appTitle');
